import { string } from "yup";
import { Database, DatabaseLoadBalancer, InternalLoadBalancer } from "./types";

const IPv4ToInt = (ip: string) =>
  ip.split(".").reduce((int, oct) => (int << 8) + parseInt(oct, 10), 0) >>> 0;

export const isIPv4InCIDR = (ip: string, cidr: string) => {
  const CIDRSubstrings = cidr.split("/");
  const range = CIDRSubstrings[0];
  const bits = CIDRSubstrings[1];
  const mask = ~(2 ** (32 - Number(bits)) - 1);
  return (IPv4ToInt(ip) & mask) === (IPv4ToInt(range) & mask);
};

export const PUBLIC_LB_ADDRESS_WARNING =
  "Disabling the public load balancer releases its IP address and disconnects public clients. Re-enabling it can assign a different IP address. Update your clients and DNS after enabling it again.";

export const internalLoadBalancerNameSchema = string()
  .required()
  .max(32)
  .matches(
    /^[a-z]([-a-z0-9]*[a-z0-9])?$/,
    "Use lowercase letters, digits and dashes, starting with a letter."
  );

export const internalLoadBalancerRequests = (
  database: Database
): InternalLoadBalancer[] =>
  (database.internal_load_balancers ?? []).map(
    ({ name, subnet_id, private_static_ip, ip_acl }) => ({
      name,
      subnet_id,
      private_static_ip: private_static_ip ?? "",
      ip_acl: ip_acl ?? []
    })
  );

export const poolerAddress = (
  lb?: DatabaseLoadBalancer
): string | undefined => {
  if (!lb?.pooler) return undefined;
  const { host, port, ready, message } = lb.pooler;
  return ready && host ? `${host}:${port}` : message || "Provisioning";
};
